import { valueOrDefault } from 'src/app/shared/commons/Utils';
import { Component, ElementRef, Input, Renderer2, ChangeDetectorRef } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'invalid-feedback',
  templateUrl: './invalid-feedback.component.html',
  styleUrls: ['./invalid-feedback.component.scss']
})
export class InvalidFeedbackComponent {

  @Input() field;
  @Input() label;
  @Input() complement;
  @Input() value;
  @Input() minCurrency;
  @Input() maxCurrency;
  @Input() isPercent = false

  constructor(
    private cdr: ChangeDetectorRef,
    private renderer: Renderer2,
    hostElement: ElementRef) {
    renderer.addClass(hostElement.nativeElement, 'invalid-feedback')
  }

  required(control) {
    return control?.touched && control?.errors?.required;
  }

  invalid(control) {
    return valueOrDefault(control?.errors?.invalid || control?.errors?.mask, false);
  }

  invalidPassword(control) {
    return !control?.errors?.required && control?.errors?.invalidPassword;
  }

  minLength(control) {
    return control?.errors?.minlength
  }

  maxLength(control) {
    return control?.errors?.maxlength
  }

  pattern(control) {
    return control?.errors?.pattern;
  }

  date(control) {
    return !control?.errors?.required && (control?.errors?.invalidDate);
  }

  isMinor(control) {
    return !control?.errors?.required && (control?.errors?.isMinor);
  }

  minDate(control: AbstractControl) {
    if (!control?.errors?.required && control?.errors?.bsDate?.minDate) {
      control?.setValue(control?.errors?.bsDate.minDate)
      this.cdr.detectChanges()
    }
  }

  minValue(control) {
    return !control?.errors?.required && (control?.errors?.minValue || control?.errors?.min)
  }

  maxValue(control) {
    return !control?.errors?.required && (control?.errors?.maxValue || control?.errors?.max)
  }

  confirmPassword(control) {
    return !control?.errors?.required && control?.errors?.doNotMatch;
  }
}
